import Vue from 'vue';
import Vuex from 'vuex';
import login from './modules/login';
import alert from './modules/alert';
import contextMenu from "./modules/contextMenu";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    login,
    alert,
    contextMenu,
  },
  state: {
      user: null
  },
  mutations: {
      setAuthUser(state, user) {
          state.user = user;
      }
  },
  getters: {
      isLoggedIn(state) {
          return state.user !== null;
      }
  }
})